import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import { EAR_CLEANING_OPTIONS } from './constants'
import useGroomingProfile from './hooks/useGroomingProfile'

const EarCleaning = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading } = useGroomingProfile()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			newValues[attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		const o = Object.entries(EAR_CLEANING_OPTIONS).map(([key, value]) => {
			return {
				title: value,
				disabled: loading || wizard_state[attr] === key,
				selected: wizard_state[attr] === key,
				onSelected: () => handleSelection(key)
			}
		})

		return o
	}, [handleSelection, loading, wizard_state, attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default EarCleaning
